import Nullstack from 'nullstack';
export default function IconSitemap({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sitemap",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "15",
    width: "6",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("rect", {
    x: "15",
    y: "15",
    width: "6",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("rect", {
    x: "9",
    y: "3",
    width: "6",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "12"
  }), " ");
}